import { render } from "./ChatPreview.vue?vue&type=template&id=128846f9&scoped=true"
import script from "./ChatPreview.vue?vue&type=script&lang=ts"
export * from "./ChatPreview.vue?vue&type=script&lang=ts"

import "./ChatPreview.vue?vue&type=style&index=0&id=128846f9&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-128846f9"

export default script
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QChatMessage from 'quasar/src/components/chat/QChatMessage.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QSeparator,QChatMessage});
